function fnDMSClock(sDMSC) {
	// Extract the degrees, minutes, and seconds from the DMS string
	// 472931N ==> { deg: 47, min: 29, sec: 31, dir: N }
  // 0190229E ==> { deg: 19, min: 02, sec: 29, dir: E }
  // console.log('fnDMSClock', sDMSC)
  const str = sDMSC.slice(0, sDMSC.length) // 0190229N => // 0190229
	const num = parseInt(str) + '' // 0190229 => // 190229
  const dir = sDMSC[sDMSC.length - 1]
  const deg = parseInt(num.slice(0, 2))
  const min = parseInt(num.slice(2, 4))
  const sec = parseInt(num.slice(4, 6))
  return { deg: deg, min: min, sec: sec, dir: dir }
}

function sDMSC_nDDT(sDMSC) {
  // 472931N  ==> 47.49194444444444
  // 0190229E ==> 19.04138888888889
  const clk = fnDMSClock(sDMSC)
  // Convert DMS to decimal degrees
  let dd = clk.deg + (clk.min / 60) + (clk.sec / 3600)
  // If the direction is South or West, make the decimal degree negative
  if (clk.dir === 'S' || clk.dir === 'W') {
    dd = -dd
  }
  return dd
}

function sDMSC_sDMS(dmsc) {
  // 472931N ==> 47°29`31"N
  // 0190229E ==> 19°02`29"E
  const clk = fnDMSClock(dmsc)
  const deg = (clk.deg + '').padStart(2, '0')
  const min = (clk.min + '').padStart(2, '0')
  const sec = (clk.sec + '').padStart(2, '0')
  return deg + '°' + min + "'" + sec + '"' + clk.dir
}

function sDMS_nDDT(sDMS) {
	// 47°29`31"N ==> 47.49194444444444
  // 19°02`29"E ==> 19.04138888888889
  return sDMSC_nDDT(sDMS_sDMSC(sDMS))
}

function sDMS_sDMSC(sDMS) {
	// 47°29`31"N ==> 472931N
  // 19°02`29"E ==> 0190229E
  const dir = sDMS[sDMS.length - 1]
  const num = sDMS.replace(/[^\d.-]+/g, '')
  const zer = dir == 'E' ? '0' : ''
  return zer + num + dir
}

function aDMS_aDDT(aDMS) {
  // ['472931N', '0190229E'] ==> ['47.49194444444444', '19.04138888888889']
  if (typeof aDMS === 'undefined') {
    console.error('convertCoordinates input is undefined.')
    return false
  }
  if (aDMS.length !== 2) {
    console.error('The input array must contain exactly two DMS coordinates.')
    return false
  }
  let latitude = sDMSC_nDDT(aDMS[0])
  let longitude = sDMSC_nDDT(aDMS[1])
  return [latitude, longitude]
}

function aDDT_aDMS(aDDT) {
  return [nDDT_sDMSC(aDDT[0]), nDDT_sDMSC(aDDT[1])]
}

function sDMS_aDDT(dms) {
  // '472931N0190229E' ==> ['47.49194444444444', '19.04138888888889']
  return aDMS_aDDT([dms.substr(0, 7), dms.substr(7)])
}

function sDMSC_aDMSC(dmsc) {
  // '472931N0190229E' ==> ['472931N', '0190229E']
  return [dmsc.substr(0, 7), dmsc.substr(7)]
}

function sDMS_aDMS(dms) {
  // '47°29`31"N 19°02`29"E' ==> ['47°29`31"N', '19°02`29"E']
  // '47°29`31"N, 19°02`29"E' ==> ['47°29`31"N', '19°02`29"E']
  return dms.replace(',', '').split(' ')
}

function sDDT_aDDT(ddt) {
  // 47.49194444444444 19.04138888888889 ==> [47.49194444444444, 19.04138888888889]
  // 47.49194444444444, 19.04138888888889 ==> [47.49194444444444, 19.04138888888889]
  return ddt.replace(',', '').split(' ')
}

function nDDT_sDMSC(nDDT, latlon) {
	// 17.33745842863516 => 470518N
  // 47.08839037678882 => 0172015E
  let deg = nDDT | 0 // truncate dd to get degrees
  let frac = Math.abs(nDDT - deg) // get fractional part
  let min = (frac * 60) | 0; // multiply fraction by 60 and truncate
  let sec = frac * 3600 - min * 60
  sec = Math.round(sec)
  if (sec >= 60) {
    min = min + 1
    sec = 0
  }
  min = Math.round(min)
  if (min >= 60) {
    deg = deg + 1
    min = 0
  }
  let sdeg = String(deg)
  let smin = String(min)
  let ssec = String(sec)
  let out = sdeg.padStart(2, '0') + smin.padStart(2, '0') + ssec.padStart(2, '0')
  if (latlon === 'lat') {
  	return out + 'N'
  } else if (latlon == 'lon') {
  	return '0' + out + 'E'
  }
}

function nDDT_sDMS(nDDT, latlon) {
	// 17.33745842863516 => 47°29`31"N
  // 47.08839037678882 => 19°02`29"E
	const sDMSC = nDDT_sDMSC(nDDT, latlon)
  return sDMSC_sDMS(sDMSC)
}
if (typeof window !== 'undefined') {
  window.fnDMSClock = fnDMSClock
  window.sDMSC_nDDT = sDMSC_nDDT
  window.sDMSC_sDMS = sDMSC_sDMS
  window.sDMS_nDDT = sDMS_nDDT
  window.sDMS_sDMSC = sDMS_sDMSC
  window.aDMS_aDDT = aDMS_aDDT
  window.aDDT_aDMS = aDDT_aDMS
  window.sDMS_aDDT = sDMS_aDDT
  window.sDMSC_aDMSC = sDMSC_aDMSC
  window.sDMS_aDMS = sDMS_aDMS
  window.sDDT_aDDT = sDDT_aDDT
  window.nDDT_sDMSC = nDDT_sDMSC
  window.nDDT_sDMS = nDDT_sDMS
}
